// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

// Components
import Container from '../../container/container';

// Styles
import ContentStyles from './content.styles';

export default function Content({ layout }) {
  const content = layout?.content;
  const width = layout?.width;

  if (!content) return '';

  return (
    <ContentStyles width={width}>
      <Container fullWidth={width === 'large'}>
        <div className="inner">{parse(content)}</div>
      </Container>
    </ContentStyles>
  );
}

Content.propTypes = {
  layout: PropTypes.shape({
    content: PropTypes.string,
    width: PropTypes.string,
  }),
};

Content.defaultProps = {
  layout: {},
};
